export default __webpack_public_path__ + "static/media/LeoLabs.dfaa9f16.png";